import { getPermittedTerminals } from "@/Utils/authUtils";
import { trpc } from "@/Utils/trpc";

import { useEffect } from "react";

import { useTerminalsState } from "../../States/Terminals";
import { useConfig } from "./useConfig";

/**
 * Use terminals hook, used to manage terminals. The underlying state is managed by useTerminalsState.
 */
export const useTerminals = () => {
  const { isMWM } = useConfig();
  const { setTerminalState } = useTerminalsState();

  const {
    data,
    isLoading: isLoadingTerminals,
    refetch,
  } = trpc.terminals.getAll.useQuery();

  useEffect(() => {
    const { allTerminals, terminals } = getPermittedTerminals(data, isMWM);
    setTerminalState({ allTerminals, terminals });
  }, [data, setTerminalState, isMWM]);

  const refetchTerminals = async () => {
    await refetch();
    const { allTerminals, terminals } = getPermittedTerminals(data, isMWM);
    setTerminalState({ allTerminals, terminals });
  };

  const { mutateAsync: updateTerminal, isPending: isUpdatingTerminal } =
    trpc.terminals.update.useMutation();

  const {
    mutateAsync: updateCoreTerminalConfig,
    isPending: isUpdatingCoreTerminalConfig,
  } = trpc.terminals.updateConfig.useMutation({
    onSuccess: async () => {
      await refetchTerminals();
    },
  });

  return {
    refetchTerminals,
    isLoadingTerminals,
    updateTerminal,
    isUpdatingTerminal,
    updateCoreTerminalConfig,
    isUpdatingCoreTerminalConfig,
  };
};
